<template>
    <div class="bax-search-title">
        <div class="bax-form-wrapper">
            <form name="patientSearchForm">
                <div class="bax-section-title d-flex align-items-center">
                    <h5>
                        Showing
                        {{ patients.length }}
                        results for
                        “{{ keyword }}”
                    :</h5>
                    <div
                        class="bax-sort-block d-flex justify-content-between
                        align-items-center ml-auto"
                    >
                        <label>sort by</label>
                        <select @change="sortResult">
                            <option value="firstName">Firstname</option>
                            <option value="lastName">Surname</option>
                            <option value="patientID">Patient ID</option>
                            <option value="dateOfBirth">DOB</option>
                            <option value="wardId">Ward</option>
                            <option value="">Last Order</option>
                        </select>
                        <div class="bax-sort-icon">
                            <a href="javascript:;" title="Sort by">
                                <i class="icon-arrow-down"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="bax-order-list bax-order-list-radio">
                    <ul>
                        <li
                            v-for="(patient, index) in patientList"
                            :key="index"
                            class="d-flex flex-wrap align-items-center"
                            @click="patientSelected(patient.patientId)"
                        >
                            <input
                                type="radio"
                                name="yes"
                                :id="patient.baxterPatientId"
                                class="css-checkbox"
                                :value="patient.patientId"
                                :checked="patientId === patient.patientId"
                                @change="$emit('onPatientSelect', patient.patientId);checkedDrugLines = [];onDrugSelect();"
                            >
                            <label :for="patient.baxterPatientId" class="css-label">
                                <div class="bax-order-detail">
                                    <ul class="bax-patient-info d-flex">
                                        <li>
                                            First Name
                                            <strong>{{ patient.firstName ? patient.firstName : '--' }}</strong>
                                        </li>
                                        <li>
                                            Last Name
                                            <strong>{{ patient.lastName ? patient.lastName : '--' }}</strong>
                                        </li>
                                        <li>
                                            Patient ID (MRN)
                                            <strong>{{ generalPatientID(patient) }}</strong>
                                        </li>
                                    </ul>
                                    <ul class="d-flex flex-wrap">
                                        <li>DOB: <strong>{{ patient.dateOfBirth?patient.dateOfBirth:'--' }}</strong></li>
                                        <template v-if="patient.loadingOrders">
                                            <li>
                                                <a color="default" class="ml-auto bax-btn bax-btn-white bax-btn-mini" @click.prevent="retrievePreviousOrders(patient.patientId)"><i class="icon-chevron-down"></i>Loading Previous Orders...</a>
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li v-if="!patient.recentOrders">
                                                <a color="default" class="ml-auto bax-btn bax-btn-white bax-btn-mini" @click.prevent="retrievePreviousOrders(patient.patientId)"><i class="icon-chevron-down"></i>Check for Previous Orders</a>
                                            </li>
                                            <li v-if="patient.recentOrders">
                                                <a color="default" class="ml-auto bax-btn bax-btn-white bax-btn-mini" @click.prevent="retrievePreviousOrders(patient.patientId)"><i class="icon-chevron-up"></i>Hide Previous Orders</a>
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </label>
                            <div class="bax-order-recent" v-if="patient.recentOrders">
                                <table>
                                    <tr>
                                        <th class="column-reorder">
                                            Reorder?
                                        </th>
                                        <th>
                                            Order Date
                                        </th>
                                        <th>
                                            Drug Name
                                        </th>
                                    </tr>
                                    <tbody>
                                    <tr v-for="(orderLine, orderLineIndex) in patient.recentOrders" :key="orderLineIndex">
                                        <td class="column-reorder">
                                            <input type="checkbox" :id="orderLine.concurrencyGUID" :value="orderLine"  @change="onDrugSelect" v-model="checkedDrugLines">
                                        </td>
                                        <td>
                                            {{ orderLine.orderDateFormatted }}
                                        </td>
                                        <td>
                                            {{ generateDrugName(orderLine) }}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                    </ul>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import arraySort from 'array-sort';
import OrderService from '@/core/api/order/order.service';
import Vue from 'vue';
import utilsMixin from '@/mixins/utilsMixin';

export default {
    name: 'SearchPatientsList',
    mixins: [utilsMixin],
    props: {
        patients: {},
        keyword: {},
    },
    data() {
        return {
            patientId: '',
            checkedDrugLines: [],
        };
    },
    computed: {
        patientList() {
            return this.patients;
        },
    },
    watch: {
        //
      patients: {
        immediate: true,
          deep: true,
          handler() {
            this.$emit('onPatientSelect', this.patientId);
        },
      },
    },
    methods: {
        onDrugSelect() {
             this.$emit('onDrugSelect', this.checkedDrugLines);
        },
        generalPatientID(value) {
            if (value && value.patientId !== '') {
                if (value.patientId.search(/\*\d+\*/) === -1) {
                    return value.patientId;
                }

                return '';
            }

            return '';
        },
        patientSelected(id) {
            this.patientId = id;
            this.$emit('onPatientSelect', this.patientId);
        },
        sortResult(e) {
            if (e.target.value !== '') {
                const r = this.patients;

                if (e.target.value === 'dateOfBirth') {
                    /* eslint-disable */
                    this.patients = r.sort((a, b) => new Date(a.dateOfBirth) - new Date(b.dateOfBirth));
                } else {
                    this.patients = arraySort(r, e.target.value);
                }
            }
        },
        retrievePreviousOrders(id) {
            let patient = false;
            let patientID = false;
            for (let i = 0; i < this.patients.length; i += 1) {

                if (this.patients[i].patientId === id) {
                    //this.patients[i].recentOrders = data;
                    patient = this.patients[i];
                    patientID = i;
                }
            }
            if (patient) {

                if (patient.recentOrders)
                {
                    patient.recentOrders = false;
                    Vue.set(this.patients, patientID, patient);
                }
                else
                {
                    patient.loadingOrders = true;
                    Vue.set(this.patients, patientID, patient);
                    OrderService.searchOrders(  {'patientid' : id } )
                        .then((res) => {
                            const { data } = res;
                            patient.loadingOrders = false;
                            patient.recentOrders = data;
                            Vue.set(this.patients, patientID, patient);
                        });
                }
            }
            this.checkedDrugLines = [];
            this.patientId = id;
        }
    },
    created() {
    }
};
</script>
